// Cihaz (terminal) yerel ayarları — her fiziksel cihazda ayrı saklanır (localStorage).
const KEY = "groot_device";

export const getDevice = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; }
};
export const setDevice = (d) => {
  try { localStorage.setItem(KEY, JSON.stringify(d)); } catch { /* ignore */ }
};
export const deviceFlag = (k, def) => {
  const d = getDevice();
  return d[k] === undefined ? def : d[k];
};
